<template>
<div class="QuoteView__container">
    <div id="QuoteView" class="container">
        <div class="title-page print-height-100-vh">
            <div class="container title-page__block">
                <div class="row">
                    <div class="col-12 title-page__background px-3 px-lg-5 position-relative">
                        <h1 class="font-heading text-uppercase wm-color-yellow text-left text-lg-right">{{quote.Title}}</h1>
                        <div class="title-page__date font-primary font-size-medium text-right px-5 d-none d-lg-block">{{formatDate(quote.Date)}}</div>
                        <div class="font-primary font-size-medium py-5 d-lg-none text-white">{{formatDate(quote.Date)}}</div>
                    </div>
                </div>
            </div>
            <div class="container p-0 title-page__footer">
                <div class="row pt-5 pb-0 py-lg-5 px-5 d-lg-flex align-items-center">
                    <div class="col-md-3 col-lg-6 text-center pb-5 pb-md-0">
                        <img class="webmad-logo" src="@/assets/img/webmad-logo.svg" alt="Webmad">
                    </div>
                    <div class="col-md-9 col-lg-6 text-center text-md-right">
                        <div class="font-primary font-size-normal"><span class="font-primary font-weight-bold">P:</span> 0800 932 623</div>
                        <div class="font-primary font-size-normal"><span class="font-primary font-weight-bold">E:</span> info@webmad.co.nz</div>
                        <div class="font-primary font-size-normal"><span class="font-primary font-weight-bold">A:</span> 69 Corsair Drive, Wigram</div>
                    </div>                 
                </div>
                <div class="footer mt-5">

                </div>
            </div>
        </div>

        <div class="container project-outline__block print-flex-grow">
            <div class="row print-height-100-percent">
                <div class="col-12 py-5 project-outline__header">
                    <h2 class="font-heading text-uppercase">Project Outline</h2>
                </div>
                <div class="col-12 project-outline__background py-lg-5">
                    <div class="row pl-4 pl-lg-0 py-lg-5">
                        <div class="offset-lg-4 col-lg-8 bg-white my-5 p-5 font-primary border-left shadow" v-html="quote.Summary">
                            
                        </div>
                    </div>
                </div>                
            </div>
        </div>
        <div class="timeline__block--wrapper">
            <div class="container timeline__block gradient-bg p-lg-5 my-5 shadow print-height-100-vh">
                <div class="row pl-4 py-4 py-lg-0 pl-lg-0 p-lg-5">
                    <div class="col-12 bg-white border-left p-4 p-lg-5 shadow">
                        <h2 class="font-heading text-uppercase pb-5">Timeline</h2>
                        <div class="row pb-3 pb-lg-5" v-for="milestone in milestones" :key="milestone.id">
                            <div class="col-12 d-flex justify-content-between">
                                <div class="text-uppercase font-weight-bold font-primary">{{ milestone.MilestoneName }}</div>
                                <div class="font-weight-bold font-primary">{{ milestone.Timeframe }}</div>
                            </div>
                            <div class="col-12">
                                <div class="spacer my-2"></div>
                            </div>
                            <div class="col-12 font-primary" v-html="milestone.Description">
                                
                            </div>                        
                        </div>
                        <div class="row pt-3 pt-lg-5">
                            <div class="col-12 d-flex justify-content-between">
                                <div class="text-uppercase font-weight-bold font-primary font-size-medium">TOTAL TIME</div>
                                <div class="font-weight-bold font-primary font-size-medium">{{quote.MilestoneEstimate}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

         <div class="print-page-break print-flex-grow">
            <div class="container project-scope__block gradient-bg p-lg-5 my-5 shadow print-height-100-percent">
                <div class="row pl-4 py-4 py-lg-0 pl-lg-0 p-lg-5 print-page-break">
                    <div class="col-12 bg-white border-left p-4 p-lg-5 shadow print-page-break">
                        <h2 class="font-heading text-uppercase pb-5">Project Scope</h2>
                        <div class="row pb-3 pb-lg-5"  v-for="(heading,index) in quoteItems" :key="index">
                            <div class="col-12 d-flex justify-content-between">
                                <div class="text-uppercase font-weight-bold font-primary">{{heading[0].Heading}}</div>
                                <div class="font-weight-bold font-primary">{{index +1 }}</div>
                            </div>
                            <div class="col-12">
                                <div class="spacer my-2"></div>
                            </div>  
                            <div class="pb-3 col-12" v-for="(quoteItem,index) in heading" :key="index">
                            <div class="row">
                            <div class="col-12 d-flex justify-content-between pb-2">
                                <div class="font-weight-normal font-primary">{{quoteItem.Item}}</div>
                                <div class="font-weight-normal font-primary">{{formatValueCurrency(quoteItem.TotalValue)}}</div>
                            </div>                        
                            <div class="col-12 font-primary" v-html="quoteItem.Description">
                                
                            </div> 
                            </div>
                            </div>                                             
                        </div>
                        <div class="row pt-lg-5">
                            <div class="col-12">
                                <div class="spacer my-2"></div>
                            </div>                        
                            <div class="col-12 d-flex justify-content-between">
                                <div class="text-uppercase font-weight-bold font-primary font-size-medium">Total (GST Exc)</div>
                                <div class="font-weight-bold font-primary font-size-medium">${{quote.Total | formatTotal}}</div>
                            </div>
                        </div>                    
                    </div>
                </div>
            </div>
        </div>
        <div class="print-page-break" v-if="optionalQuoteItems.length">
            <div class="container project-scope__block gradient-bg p-lg-5 my-5 shadow print-height-100-vh" v-if="optionalQuoteItems.length">
                <div class="row pl-4 py-4 py-lg-0 pl-lg-0 p-lg-5">
                    <div class="col-12 bg-white border-left p-4 p-lg-5 shadow">
                        <h2 class="font-heading text-uppercase pb-5">Optional Extras</h2>
                        <div class="row pb-3 pb-lg-5"  v-for="(item,index) in optionalQuoteItems" :key="index">
                            <div class="col-12 d-flex justify-content-between">
                                <div class="text-uppercase font-weight-bold font-primary">{{item.Item}}</div>
                                <div class="font-weight-bold font-primary">{{formatValueCurrency(item.TotalValue)}}</div>
                            </div>
                            <div class="col-12">
                                <div class="spacer my-2"></div>
                            </div>                       
                            <div class="col-12 font-primary" v-html="item.Description">
                                
                            </div>                                             
                        </div>                   
                    </div>
                </div>
            </div>
        </div>
        <div class="print-height-100-vh" v-if="ongoingQuoteItems.length">
            <div class="container project-scope__block gradient-bg p-lg-5 my-5 shadow print-height-100-vh" v-if="ongoingQuoteItems.length">
                <div class="row pl-4 py-4 py-lg-0 pl-lg-0 p-lg-5">
                    <div class="col-12 bg-white border-left p-4 p-lg-5 shadow">
                        <h2 class="font-heading text-uppercase pb-5">Ongoing Services</h2>
                        <div class="row pb-5"  v-for="(item,index) in ongoingQuoteItems" :key="index">
                            <div class="col-12 d-flex justify-content-between">
                                <div class="text-uppercase font-weight-bold font-primary">{{item.Item}}</div>
                                <div class="font-weight-bold font-primary">{{formatValueCurrency(item.TotalValue)}}</div>
                            </div>
                            <div class="col-12">
                                <div class="spacer my-2"></div>
                            </div>                       
                            <div class="col-12 font-primary" v-html="item.Description">
                                
                            </div>                                             
                        </div>                   
                    </div>
                </div>
            </div>        
        </div>
        <div v-if="additionalPages.length" class="print-height-100-vh print-page-break">
            <div class="container project-scope__block gradient-bg p-lg-5 my-5 shadow print-height-100-vh print-page-break" v-for="(item,index) in additionalPages" :key="index">
                <div class="row pl-4 py-4 py-lg-0 pl-lg-0 p-lg-5">
                    <div class="col-12 bg-white border-left p-4 p-lg-5 shadow">
                        <h2 class="font-heading text-uppercase pb-5">{{item.Heading}}</h2>
                        <div class="row pb-5">                     
                            <div class="col-12 font-primary" v-html="item.Description">
                                
                            </div>                                             
                        </div>                   
                    </div>
                </div>
            </div> 
        </div>
        <div class="why-webmad__block print-height-100-vh print-flex-grow">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="font-heading text-uppercase">Why Webmad?</h2>
                    </div>
                </div>
            </div>
            <div class="container gradient-bg mb-5 print-height-100-percent">
                <div class="row px-2 py-5 p-lg-5">
                    <div class="col-12 pb-5 pb-lg-0 p-lg-5">
                        <div class="row">
                            <div class="col-2 text-left">
                                <img class="img-fluid" src="@/assets/img/brain.svg">
                            </div>
                            <div class="col-10 text-white font-primary">
                                <h3 class="wm-color-yellow text-uppercase font-heading pb-3">We love a challenge, and we're focused on solutions</h3>
                                <p>Here at Webmad, customised and complex web systems are our specialty. We’re dedicated to supporting your needs with tailored solutions, whether it’s a simple website, or complex software development</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 pb-5 pb-lg-0 p-lg-5">
                        <div class="row">
                            <div class="col-2">
                                <img class="img-fluid"  src="@/assets/img/price.svg">
                            </div>
                            <div class="col-10 text-white font-primary">
                                <h3 class="wm-color-yellow text-uppercase font-heading pb-3">We offer experience and quality at a reasonable price</h3>
                                <p>Our team have designed hundreds of websites and technical tools for simple to even the most complicated needs, and all at a very competitive rate. Webmad have been providing successful outcomes for our clients for almost 10 years, and our highly skilled team have years of combined experience, and cover all the bases needed for.</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-12  p-lg-5">
                        <div class="row">
                            <div class="col-2">
                                <img class="img-fluid" src="@/assets/img/handshake.svg">
                            </div>
                            <div class="col-10 text-white font-primary">
                                <h3 class="wm-color-yellow text-uppercase font-heading pb-3">We're here for support</h3>
                                <p>Unlike many companies, we’re located on a New Zealand time zone. This means we can easily work with you every step of the way and are available during your business hours by phone and in person for meetings and planning.</p>
                            </div>
                        </div>
                    </div>
                                                    
                </div>
            </div>
        </div>
        <div class="project-team__block print-flex-grow page-break">
            <div class="container gradient-bg p-lg-5 mt-5 shadow print-height-100-percent">
                <div class="row pl-4 py-4 pl-lg-0 py-lg-0 p-lg-5">
                    <div class="col-12 border-left bg-white p-4 p-lg-5">
                        <h2 class="font-heading text-uppercase pb-3">Your Project Team</h2>
                        <p class="font-primary pb-5">Webmad is a venture born in 2012 when Directors, Stephen and Isaac joined forces to bring their many years of IT and web development expertise together. The company has grown to include a great team with wide ranging skills. Here are the team members you will be working with.</p>
                        <div class="row pb-5">
                            <div class="col-6 col-lg-12 pb-4" v-for="(s,index) in staff" :key="index">
                                <div class="row">
                                    <div class="col-lg-3" v-if="s.Photo">
                                        <img class="img-fluid staff-photo" :src="'//quotes.webmad.co.nz' + s.Photo.url">
                                    </div>
                                    <div class="col-lg-9 pt-3 pt-lg-0">
                                        <h5 class="font-weight-bold font-primary">{{s.Name}}</h5>
                                        <h5 class="font-primary">{{s.Role}}</h5>
                                        <div class="spacer spacer--light my-3"></div>
                                        <p class="font-primary d-none d-lg-block">{{s.Details}}</p>
                                    </div> 
                                </div>
                            </div>                                                                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>    
</template>

<script>
import Vue from 'vue'
import moment from "moment";
import JQuery from "jquery";
import axios from "axios";
var numeral = require("numeral");

Vue.filter("formatTotal", function (value) {
return numeral(value).format("0,0.00"); // displaying other groupings/separators is possible, look at the docs
});

window.$ = JQuery;
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
 
export default {
    name: "QuoteView",
    data() {
        return {
            quote: [],
            milestones: [],
            quoteItems: [],
            optionalQuoteItems: [],
            additionalPages: [],
            ongoingQuoteItems: [],
            contextText: {
                heading: 'Viewing Quote',
            },
            staff: [],

        };
    },
    watch: {

    },
    methods: {
        formatValueCurrency(value) {
            console.log('formatValueCurrency')
            console.log(value)
            if(value.includes('$') || isNaN(value)){
                return value;
            }else{
                return numeral(value).format("$0,0.00");
                //value = "$" + value;
            }
             //return value;
             
        },
        formatDate(date){
            return moment(date).format('Do MMMM YYYY');
        },
        async submitHandler(data) {

        },
        async formatQuoteItems(quoteItemsTemp) {
            let quoteItems = [];
            let optionalQuoteItems = [];
            let ongoingQuoteItems = [];
            quoteItemsTemp.forEach((element) => {
                let key = element.Heading.replace(/\s/g, '');
                if(key == 'OptionalExtras'){
                    optionalQuoteItems.push(element);
                    
                }
                else if(key == 'OngoingServices'){
                    ongoingQuoteItems.push(element);
                    
                }else{
                    if(!quoteItems[key]){
                        quoteItems[key] = [];
                    }else{
                        //
                    }
                    quoteItems[key].push(element); 
                }                

            } )

            this.optionalQuoteItems = optionalQuoteItems;
            this.ongoingQuoteItems = ongoingQuoteItems;
            let data = [];
            for (var key of Object.keys(quoteItems)) {
                console.log(key + " -> " + quoteItems[key])
                data.push(quoteItems[key]);
            }
            

            return data;
        },        
    },
    async mounted() {

        if (this.$route.params.id) {
            axios
                .get('/api/quotespublics/?hashId=' + this.$route.params.id)
                .then(response => {
                    const formData = response.data;
                    console.log(response);
                    console.log(response.data);

                    this.quote = formData[0].quoteId;
                    const quote = formData[0].quoteId;
                    //console.log(quote);
                    this.milestones = quote.Milestones;

                    let quoteItemsTemp = quote.QuoteItem;
                    this.additionalPages = quote.AdditionalPages;

                    this.formatQuoteItems(quoteItemsTemp).then(responseData => {
                        this.quoteItems = responseData;
                        console.log(this.quoteItems)
                    })

                    //this.quoteItems = this.formatQuoteItems(quoteItemsTemp);
                    
                   
                    //console.log(this.quoteItems)
                })
                .catch(error => {
                    console.log(error)
                    this.error = error;
                })

                axios
                .get('/api/quotespublics/?getStaff=1&hashId=' + this.$route.params.id)
                .then(response => {
                    const formData = response.data;
                    this.quote = formData[0].quoteId;
                    const quote = formData[0].quoteId;
                    
                    
                    this.staff = quote.webmadstaffs;
                    console.log(this.staff);
                })
                .catch(error => {
                    console.log(error)
                    this.error = error;
                })                
        }

    },
};
</script>

<style scoped>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

#header {
    display: none !important;
}
</style>
